import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "grading-periods",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grading-periods" */ "./components"),
      import(
        /* webpackChunkName: "grading-periods" */ "./modules/GradingPeriodsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      const key = importedModule1.NAME;
      injectReducer(store, {
        key,
        reducer,
      });
      return component;
    })
  ),
});
